/** Boxes as printed on ICS 261-CG, Incident Accountable Resource Tracking Sheet. */

export const ICS261_BOX_LABELS = {
  incidentName: '1. Incident Name:',
  incidentLocation: '2. Incident Location:',
  fundingSource: '3. Funding Source:',
  projectNumber: '4. Project Number:',
  items: '5–16. Accountable items',
} as const;

export const ICS261_ITEM_COLUMNS = [
  { key: 'in_service_date', label: 'In service date' },
  { key: 'acquisition_method', label: 'Acquisition method' },
  { key: 'item_name', label: 'Item name and model' },
  { key: 'serial_number', label: 'Serial number' },
  { key: 'actual_cost', label: 'Actual cost' },
  { key: 'request_number', label: 'ICS 213RR request number' },
  { key: 'issued_to_location', label: 'Issued to location' },
  { key: 'issued_to', label: 'Issued to' },
  { key: 'issued_date', label: 'Issued date' },
  { key: 'date_returned', label: 'Date returned' },
  { key: 'current_disposition', label: 'Current disposition' },
  { key: 'final_disposition', label: 'Final disposition' },
] as const;
